"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rainbow;
var circle = 211;
var generator = 17;
var offset = 50;
/** generate 211 * 6 = 1266 different colors */

function rainbow() {
  var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var h = offset;

  for (var i = 0; i < step % circle; i++) {
    h = (h + generator) % circle;
  }

  h = Math.round(h / circle * 360);
  var a = Math.cos((h - 60) / 180 * Math.PI);
  var round = (3 + Math.floor(step / circle)) % 6;
  var b = 50 + 5 * a - 5 * (round - 3);
  var s = 100 - 30 * a;
  return "hsl(".concat(h, ", ").concat(s, "%, ").concat(b, "%)");
}